export default "__VITE_ASSET__Iv_iuI3Z__"